import {passwordRules} from "./passwordRules";

export type PasswordStrength = "weak" | "medium" | "strong";

export function getPasswordStrength(password: string): PasswordStrength {
    if (!password) return "weak";

    const passed = passwordRules.filter(r => r.test(password)).length;

    if (passed <= 2) return "weak";
    if (passed === 3 || passed === 4) return "medium";
    return "strong";
}